import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const CardHeader: FunctionComponent<Props> = ({
    action,
    className = '',
    testId = TEST_ID,
    title
}) => (
    <header className={`${styles.cardHeader} ${className}`} data-testid={testId}>
        <span className={styles.title}>{title}</span>

        {action ? <div className={styles.action}>{action}</div> : null}
    </header>
);

export default CardHeader;
